
/**
 * Configuration service for all application-wide settings and keys
 */

interface AppConfig {
  recaptcha: {
    siteKey: string;
  };
  api: {
    baseUrl: string;
  };
  analytics: {
    googleAnalytics: {
      measurementId: string;
    };
    googleAds: {
      conversionId: string;
      conversionLabel: string;
    };
  };
  // Add other configuration categories as needed
}

// Central configuration object
const appConfig: AppConfig = {
  recaptcha: {
    siteKey: '6LfP_i8rAAAAALzJQZMRuQYV_Wia_Ij5Ux9k8XNK', // Replace with your actual site key in production
  },
  api: {
    baseUrl: 'https://api.afsprakenmaker.be', // Replace with your actual API base URL in production
  },
  analytics: {
    googleAnalytics: {
      measurementId: 'G-E3XRGGN7W0', // Updated with the provided GA4 measurement ID
    },
    googleAds: {
      conversionId: '349578836',
      conversionLabel: 'bAdICLrWptoYENTM2KYB',
    }
  }
};

/**
 * Get the reCAPTCHA site key
 * @returns The configured reCAPTCHA site key
 */
export const getRecaptchaSiteKey = (): string => {
  return appConfig.recaptcha.siteKey;
};

/**
 * Get the full reCAPTCHA script URL with site key
 * @returns The reCAPTCHA script URL
 */
export const getRecaptchaScriptUrl = (): string => {
  return `https://www.google.com/recaptcha/api.js?render=${getRecaptchaSiteKey()}`;
};

/**
 * Get the API base URL
 * @returns The configured API base URL
 */
export const getApiBaseUrl = (): string => {
  return appConfig.api.baseUrl;
};

/**
 * Get the Google Analytics Measurement ID
 * @returns The configured GA4 measurement ID
 */
export const getGAMeasurementId = (): string => {
  return appConfig.analytics.googleAnalytics.measurementId;
};

/**
 * Get the Google Ads Conversion ID
 * @returns The configured Google Ads conversion ID
 */
export const getGAdsConversionId = (): string => {
  return appConfig.analytics.googleAds.conversionId;
};

/**
 * Get the Google Ads Conversion Label
 * @returns The configured Google Ads conversion label
 */
export const getGAdsConversionLabel = (): string => {
  return appConfig.analytics.googleAds.conversionLabel;
};

/**
 * Check if the application is running in development mode
 * @returns True if running in development mode
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV || import.meta.env.MODE === 'development';
};

/**
 * Development-only console logging utility
 * Disabled to reduce console noise
 * @param args - Arguments to log (same as console.log)
 */
export const devLog = (...args: any[]): void => {
  // Logging disabled to reduce console noise
  // if (isDevelopment()) {
  //   console.log(...args);
  // }
};
